import enLocale from './en_us'
import zhLocale from './zh_cn'
import tcLocale from './zh_tc'
import initI18n from '../tools'

import { getLangType } from '@/utils/tools.js'

export const CMHKLangMap = {
    sc: 'zhCn',
    tc: 'zhTc',
    en: 'zhTc',
}

export const i18n = initI18n({
    enLocale,
    zhLocale,
    tcLocale,
    getLang: () => {
        const lang = getLangType('lang') || getLangType()
        return CMHKLangMap[lang] || lang
    },
    defaultLang: 'zhTc',
})